// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  appID: '1:1061914946151:web:0beb7fad4793f8620502c2',
  config: {
    apiKey: 'AIzaSyBgHEVphibhzaZ-EOXGUWyIaMXn5vNvlfM',
    authDomain: 'tradeapp-602ed.firebaseapp.com',
    databaseURL: 'https://tradeapp-602ed.firebaseio.com',
    projectId: 'tradeapp-602ed',
    storageBucket: 'tradeapp-602ed.appspot.com',
    messagingSenderId: '1061914946151',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
